
export default function AchievementsSection() {
  const achievements = [
    {
      title: '国家级奖项',
      awards: [
        { name: '中国茶叶行业百强企业', year: '2023', level: 'national' },
        { name: '全国农业产业化重点龙头企业', year: '2022', level: 'national' },
        { name: '中国茶叶流通协会理事单位', year: '2021', level: 'national' }
      ],
      icon: 'ri-medal-line',
      color: 'from-red-500 to-red-600'
    },
    {
      title: '质量认证',
      awards: [
        { name: 'ISO9001质量管理体系认证', year: '2018', level: 'international' },
        { name: '有机茶产品认证', year: '2019', level: 'organic' },
        { name: 'HACCP食品安全管理体系认证', year: '2020', level: 'safety' }
      ],
      icon: 'ri-shield-check-line',
      color: 'from-blue-500 to-blue-600'
    },
    {
      title: '行业荣誉',
      awards: [
        { name: '云南省著名商标', year: '2020', level: 'provincial' },
        { name: '西双版纳州龙头企业', year: '2019', level: 'local' },
        { name: '茶叶质量安全示范企业', year: '2021', level: 'industry' }
      ],
      icon: 'ri-trophy-line',
      color: 'from-amber-500 to-amber-600'
    },
    {
      title: '社会责任',
      awards: [
        { name: '脱贫攻坚先进企业', year: '2021', level: 'social' },
        { name: '环保模范企业', year: '2022', level: 'environmental' },
        { name: '优秀纳税人', year: '2023', level: 'tax' }
      ],
      icon: 'ri-hand-heart-line',
      color: 'from-green-500 to-green-600'
    }
  ];

  const statistics = [
    { label: '年产茶叶', value: '5000+', unit: '吨', icon: 'ri-scales-3-line' },
    { label: '直接就业', value: '1200+', unit: '人', icon: 'ri-team-line' },
    { label: '带动茶农', value: '5000+', unit: '户', icon: 'ri-community-line' },
    { label: '年销售额', value: '8', unit: '亿元', icon: 'ri-money-dollar-circle-line' }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            荣誉成就
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            15年来，我们获得了众多荣誉认可，这是对我们不懈努力的最好证明
          </p>
        </div>

        {/* Achievements Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {achievements.map((category, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 p-6"
            >
              <div className="flex items-center mb-6">
                <div className={`w-12 h-12 rounded-full bg-gradient-to-r ${category.color} flex items-center justify-center mr-4`}>
                  <i className={`${category.icon} text-white text-xl`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-800">{category.title}</h3>
              </div>
              
              <div className="space-y-3">
                {category.awards.map((award, awardIndex) => (
                  <div
                    key={awardIndex}
                    className="flex items-center justify-between p-3 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors duration-200"
                  >
                    <div className="flex-1">
                      <div className="font-medium text-gray-800">{award.name}</div>
                      <div className="text-sm text-gray-5

00">获得时间：{award.year}</div>
                    </div>
                    <div className={`px-3 py-1 rounded-full text-xs font-medium ${
                      award.level === 'national' ? 'bg-red-100 text-red-600' :
                      award.level === 'international' ? 'bg-blue-100 text-blue-600' :
                      award.level === 'provincial' ? 'bg-purple-100 text-purple-600' :
                      award.level === 'organic' ? 'bg-green-100 text-green-600' :
                      award.level === 'safety' ? 'bg-orange-100 text-orange-600' :
                      'bg-gray-100 text-gray-600'
                    }`}>
                      {award.level === 'national' ? '国家级' :
                       award.level === 'international' ? '国际认证' :
                       award.level === 'provincial' ? '省级' :
                       award.level === 'organic' ? '有机认证' :
                       award.level === 'safety' ? '安全认证' :
                       award.level === 'local' ? '州级' :
                       award.level === 'industry' ? '行业' :
                       award.level === 'social' ? '社会责任' :
                       award.level === 'environmental' ? '环保' :
                       award.level === 'tax' ? '税务' : '荣誉'}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Statistics */}
        <div className="bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl p-8 text-white">
          <div className="text-center mb-8">
            <h3 className="text-2xl font-bold mb-4">企业贡献</h3>
            <p className="text-blue-100">我们不仅追求商业成功，更致力于为社会创造价值</p>
          </div>
          
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {statistics.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="w-16 h-16 mx-auto mb-4 bg-white/20 rounded-full flex items-center justify-center">
                  <i className={`${stat.icon} text-white text-2xl`}></i>
                </div>
                <div className="text-3xl font-bold text-amber-400 mb-1">
                  {stat.value}
                  <span className="text-lg ml-1">{stat.unit}</span>
                </div>
                <div className="text-blue-100">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Awards Gallery */}
        <div className="mt-16">
          <h3 className="text-2xl font-bold text-center text-gray-800 mb-8">获奖展示</h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[1, 2, 3, 4, 5, 6, 7, 8].map((item) => (
              <div
                key={item}
                className="aspect-square bg-gray-100 rounded-lg overflow-hidden hover:shadow-lg transition-shadow duration-300"
              >
                <img
                  src={`https://public.readdy.ai/ai/img_res/ef13d411f8feba6eeeab10d8e2b03f07.jpg${item}&orientation=squarish`}
                  alt={`奖项 ${item}`}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
